<template>
  <div
    :class="[
      value ? 'bg-green-500' : 'bg-gray-500',
      disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
    ]"
    class="w-12 h-6 rounded-full shadow inline-block focus-within:shadow-outline focus-within:outline-none"
    @click="!disabled && $emit('change', !value)"
    :title="title"
  >
    <div
      :style="{
        transform: `translateX(${value ? 100 : 0}%)`,
        'transition-duration': `.25s`
      }"
      class="w-1/2 h-full bg-white rounded-full shadow"
    />
  </div>
</template>

<script>
export default {
  model: {
    event: 'change'
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>
